import { render, staticRenderFns } from "./rgmlSet.vue?vue&type=template&id=2c8c8a36&scoped=true&"
import script from "./rgmlSet.vue?vue&type=script&lang=js&"
export * from "./rgmlSet.vue?vue&type=script&lang=js&"
import style0 from "./rgmlSet.vue?vue&type=style&index=0&id=2c8c8a36&prod&lang=scss&scoped=true&"
import style1 from "./rgmlSet.vue?vue&type=style&index=1&id=2c8c8a36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c8a36",
  null
  
)

export default component.exports